module.exports = global.config = {
    auth: {

    }
        
    
}